import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import GlobalRankingLeagueView from "../../players/GlobalRankingLeagueView.tsx";

export const Route = createFileRoute('/_app/global-ranking-league')({
  component: RouteComponent,
})

function RouteComponent() {
  return <GlobalRankingLeagueView />
}
